exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://cdn.quilljs.com/1.2.6/quill.snow.css);", ""]);
exports.push([module.id, "@import url(https://unpkg.com/vue-multiselect@2.1.0/dist/vue-multiselect.min.css);", ""]);

// module
exports.push([module.id, "\n", ""]);

// exports
